module.exports = "<span title=\"{{ description|e('html_attr') }}\">\n  {{categoryTitle|e}}\n</span>\n";
